// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Currency } from '@/currency/api/types';
import { ProjectAssetAssignment } from '@/project/api/types';
import { z } from 'zod';

// Tracking view mode
export const trackingViewModeSchema = z.enum(['table', 'analytics']);
export type TrackingViewMode = z.infer<typeof trackingViewModeSchema>;

export type ProjectReportMetric = 'requestedCount' | 'totalContractValue';

export interface ProjectReportDatum {
  id: string;
  label: string;
  requestedCount: number;
  totalContractValue: number;
  totalContractValueByCurrency: Currency[];
  assignments: ProjectAssetAssignment[];
}

/** Schema defining the valid asset snapshot types */
export const assetSnapshotTypeSchema = z.enum([
  'inventory',
  'fixed-assets',
  'sold-assets',
  'scrapped-assets',
]);

/** Array of asset snapshot types for iteration */
export const assetSnapshotTypes = assetSnapshotTypeSchema.options;

/** Schema defining the valid left inventory for types */
export const leftInventoryForSchema = z.enum(['FIXED_ASSETS', 'SALE', 'SCRAP']);

/** Type representing a validated left inventory for type */
export type LeftInventoryFor = z.infer<typeof leftInventoryForSchema>;

/** Schema defining the valid asset rollforward types */
const assetRollforwardTypeSchema = z.enum(['inventory', 'fixed-assets']);

/** Array of asset rollforward types for iteration */
export const assetRollforwardTypes = assetRollforwardTypeSchema.options;

/** Schema defining the valid rollforward waterfall display metric types */
export const rollforwardWaterfallDisplayMetricTypeSchema = z.enum([
  'units',
  'dollars',
]);

/** Type representing a validated rollforward waterfall display metric type */
export type RollforwardWaterfallDisplayMetricType = z.infer<
  typeof rollforwardWaterfallDisplayMetricTypeSchema
>;
